import { initializeApp } from 'firebase/app';
import { getAuth } from 'firebase/auth';
import { getFirestore } from 'firebase/firestore';
import { getStorage } from 'firebase/storage';
import { getFunctions } from 'firebase/functions';

// TODO: Replace with your Firebase config
// MARK: USE ONLY THIS CONFIG - For production
const firebaseConfig = {
  apiKey: "AIzaSyCoSwczufYmvdHRO-zxTyAZz1LzfGW9QPE",
  authDomain: "ulloor-styles.firebaseapp.com",
  projectId: "ulloor-styles",
  storageBucket: "ulloor-styles.firebasestorage.app",
  messagingSenderId: "533692753443",
  appId: "1:533692753443:web:c036850132d8182ee73396"
};

// MARK: USE THIS CONFIG - For Dev
// const firebaseConfig = {
//   apiKey: "AIzaSyAnMBgiQ7niQyYtPp7dBXqqn4MbdNhf0-8",
//   authDomain: "ulloorsalon.firebaseapp.com",
//   projectId: "ulloorsalon",
//   storageBucket: "ulloorsalon.firebasestorage.app",
//   messagingSenderId: "282250664269",
//   appId: "1:282250664269:web:248da99714b5dd89baff04"
// };

// Admin email configuration - you can add multiple admin emails here
export const ADMIN_EMAILS = [
  "ulloorapps@gmail.com",
  // Add more admin emails as needed
  // "another-admin@ulloorstyles.com"
];

// Initialize Firebase
const app = initializeApp(firebaseConfig);

// Suppress BloomFilter errors (known issue in Firebase 12.3.0)
const originalConsoleError = console.error;
console.error = (...args) => {
  if (
    (typeof args[0] === 'string' && args[0].includes('BloomFilter error')) ||
    (args[0] && args[0].name === 'BloomFilterError')
  ) {
    // Suppress BloomFilter errors
    return;
  }
  originalConsoleError.apply(console, args);
};

// Initialize Firebase Authentication and get a reference to the service
export const auth = getAuth(app);

/**
 * Wait for auth to resolve and ensure an ID token is available for Storage/Firestore.
 * Uses a forced refresh so custom-token claims are present on the first request (avoids
 * intermittent "Missing or insufficient permissions" on the first PDF/share action).
 */
export async function ensureAuthTokenReady() {
  await auth.authStateReady();
  const user = auth.currentUser;
  if (!user) {
    throw new Error('Not signed in');
  }
  await user.getIdToken(true);
}

// Initialize Cloud Firestore and get a reference to the service
export const db = getFirestore(app);

// Initialize Firebase Storage and get a reference to the service
export const storage = getStorage(app);

// Initialize Firebase Functions and get a reference to the service
export const functions = getFunctions(app);

export default app;

